<header class="header">
  <div class="header-aside">
    <button mat-icon-button class="mx-2 btn btn-menu" id="sidebar-toggler" (click)="toggleSidebar($event)">
      <i class="material-icons">menu</i>
    </button>
    <div class="logo-block">
      <a routerLink="/" [title]="'COMMON.HOME' | translate">
        <img src="./assets/images/logo.svg" alt="Logo">
      </a>
    </div>
    <div class="d-none d-md-block d-lg-block mx-3"><app-breadcrumb></app-breadcrumb></div>
  </div>
  <div class="header-inner">
    <ul class="d-flex align-items-center gap-3">
      <li>
        <button mat-icon-button class="btn" [matMenuTriggerFor]="notificationMenu" [matBadge]="1"
          [matBadgeHidden]="!(notifications$ | async)?.result?.length" matBadgeSize="small" matBadgeColor="warn" #notificationMenuTrigger="matMenuTrigger">
          <img src="./assets/images/ic-notification.svg" alt="Icon">
        </button>
        <mat-menu #notificationMenu="matMenu" class="notification-menu">
          <div class="notification-head">
            <h5 class="notification-title">{{'NOTIFICATION.NOTIFICATIONS' | translate}}</h5>
            <button mat-icon-button (click)="$event.stopPropagation()" class="btn" [matMenuTriggerFor]="selectMenu" #selectMenuTrigger="matMenuTrigger">
              <img src="./assets/images/ic-filter.svg" alt="Icon">
            </button>
          </div>
          <div class="notification-list" relativeLoader [loading]="isNotificationLoading">
            @if ((notifications$ | async)?.result?.length > 0) {
              @for (notification of (notifications$ | async)?.result; track $index) {
                <div class="notification-item unread" (click)="$event.stopPropagation()">
                  <svg width="15" height="22" viewBox="0 0 15 22" fill="none"
                    xmlns="http://www.w3.org/2000/svg" class="notification-icon">
                    <path fill="currentColor" d="M7.12502 18C8.0908 18 8.8742 17.2166 8.8742 16.25H5.37584C5.37584 17.2166 6.15924 18 7.12502 18ZM13.0146 13.9064C12.4863 13.3387 11.4978 12.4848 11.4978 9.6875C11.4978 7.56289 10.0081 5.86211 7.99947 5.44484V4.875C7.99947 4.39184 7.60791 4 7.12502 4C6.64213 4 6.25057 4.39184 6.25057 4.875V5.44484C4.24189 5.86211 2.75221 7.56289 2.75221 9.6875C2.75221 12.4848 1.76373 13.3387 1.23545 13.9064C1.07139 14.0827 0.998652 14.2936 1.00002 14.5C1.00303 14.9484 1.35494 15.375 1.87775 15.375H12.3723C12.8951 15.375 13.2473 14.9484 13.25 14.5C13.2514 14.2936 13.1787 14.0825 13.0146 13.9064Z"/>
                  </svg>
                  <div class="notification-content">
                    <p class="title">{{ notification | dynamicLanguageField : 'title' }} </p>
                    <p class="message">
                      {{ userType === userTypes.Patient ? (notification | dynamicLanguageField : 'description') : formatNotificationMessage(notification['description']) }}
                    </p>
                    <span class="time">{{ notification.createdDate | timeDifference }}</span>
                  </div>
                  @if (showMarkRead(notification)) {
                    <div class="mark-read-area">
                      <button mat-button class="btn" (click)="markAsReadAndNavigateToEntity(notification); $event.stopPropagation()">
                        {{'COMMON.VIEW_DETAIL' | translate}}
                        <img src="./assets/images/ic-more.svg" alt="Icon">
                      </button>
                      <button mat-button class="btn" (click)="markAsRead(notification); $event.stopPropagation()">
                        {{'NOTIFICATION.MARK_AS_READ' | translate}}
                        <img src="./assets/images/ic-check-circle.svg" alt="Icon">
                      </button>
                    </div>
                  }
                </div>
              }
            } @else {
              <div (click)="$event.stopPropagation()" class="empty-state">{{ 'NOTIFICATION.NO_NEW_NOTIFICATION' | translate}}</div>
            }
          </div>
        </mat-menu>
        <mat-menu #selectMenu="matMenu" xPosition="before" yPosition="below" class="theme-menu">
          @if (showMarkAllRead((notifications$ | async)?.result)) {
            <button mat-menu-item title="Mark All As Read" (click)="markAllAsRead(); $event.stopPropagation()">{{'CLAIM.CLAIM_TRANSACTION.MARK_ALL_AS_READ' | translate}}</button>
          }
          <button mat-menu-item title="View All" (click)="routeToNotificationCenter()">
            {{'NOTIFICATION.VIEW_ALL' | translate}}
          </button>
        </mat-menu>
      </li>
      <li>
        <button mat-button class="profile-dropdown-btn" [matMenuTriggerFor]="menu">
          <div class="d-flex align-items-center">
            <img src="./assets/images/ic-user.svg" alt="Profile">
          </div>
        </button>
        <mat-menu #menu="matMenu" xPosition="before" yPosition="below" class="profile-drop-menu">
          <div class="drop-head">
            <img src="./assets/images/ic-user.svg" alt="Profile" class="user-profile-in">
            <div class="u-content">
              <h5 class="user-name">{{userFullName}}</h5>
              <p class="type">{{userTypeName}}</p>
            </div>
          </div>
          <div class="toggle-container">
            <div class="active-bg" [class.translate-ar]="currentLang() === 'ar'"></div>

            <button class="lang-btn" [class.active]="currentLang() === 'en'" (click)="setLanguage('en')">
              <img src="./assets/images/ic-flag-en.svg" alt="English" class="flag-icon">
              <span>English</span>
            </button>

            <button class="lang-btn" [class.active]="currentLang() === 'ar'" (click)="setLanguage('ar')">
              <img src="./assets/images/ic-flag-ar.svg" alt="Arabic" class="flag-icon">
              <span>عربي</span>
            </button>
          </div>
          <button mat-menu-item title="{{'COMMON.MY_PROFILE' | translate}}" (click)="onMyProfileClick()">
            <img src="./assets/images/ic-profile.svg" alt="Icon">{{'COMMON.MY_PROFILE' | translate}}
          </button>
          @if (userType !== userTypes.Patient){
            <button mat-menu-item title="{{'COMMON.CHANGE_PASSWORD' | translate}}" (click)="onChangePasswordClick()">
              <img src="./assets/images/ic-lock.svg" alt="Icon"> {{'COMMON.CHANGE_PASSWORD' | translate}}
            </button>
          }
          <button mat-menu-item (click)="logout()" title="{{'COMMON.LOGOUT' | translate}}">
            <img src="./assets/images/ic-logout.svg" alt="Icon">{{'COMMON.LOGOUT' | translate}}
          </button>
        </mat-menu>
      </li>
    </ul>
  </div>
</header>